var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\uB808\\uC774\\uC5B4_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.7,438.4c-11.7,0-21.8-4.2-30.1-12.5-8.4-8.4-12.5-18.4-12.5-30.1v-255.9c0-11.7,4.2-21.8,12.5-30.1,8.3-8.4,18.4-12.5,30.1-12.5h110.4c5.7,0,11.1,1.1,16.3,3.2,5.1,2.1,9.7,5.2,13.6,9.1l30.4,30.4h170.6c11.7,0,21.8,4.2,30.1,12.5,8.3,8.3,12.5,18.4,12.5,30.1H119.4c-11.7,0-21.8,4.2-30.1,12.5-8.4,8.4-12.5,18.4-12.5,30.1v170.6l42.1-140.2c2.8-9.2,8.1-16.6,15.7-22.1,7.6-5.5,16.1-8.3,25.3-8.3h275.1c14.6,0,26,5.8,34.4,17.3,8.3,11.6,10.6,24.1,6.7,37.6l-38.4,127.9c-2.8,9.2-8.1,16.6-15.7,22.1-7.6,5.5-16.1,8.3-25.3,8.3H76.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenter);
export default __webpack_public_path__ + "static/media/center.9c76dd968b7836ac3e20f449e2476512.svg";
export { ForwardRef as ReactComponent };